import { StDot, StDotContainer, StDotHighlight } from './Dot.styled'

type Props = {
  isSelected: boolean
  onClick: () => void
}
export function Dot({ isSelected, onClick }: Props) {
  return (
    <StDotContainer onClick={onClick}>
      <StDot>
        {isSelected && (
          // By setting layoutId, when this component is removed and a new one
          // is added elsewhere, the new component will animate out from the old one.
          <StDotHighlight layoutId='highlight' />
        )}
      </StDot>
    </StDotContainer>
  )
}
